var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-app', {
    style: _vm.appStyle
  }, [_c('v-snackbar', {
    attrs: {
      "color": _vm.notificationState.type === 'error' ? 'error' : _vm.notificationState.type === 'success' ? 'success' : _vm.notificationState.type === 'warning' ? 'warning' : 'info',
      "timeout": _vm.notificationState.timeout,
      "app": "",
      "top": "",
      "centered": "",
      "content-class": "global-notification-snackbar"
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function (_ref) {
        var attrs = _ref.attrs;
        return [_c('v-btn', _vm._b({
          attrs: {
            "text": ""
          },
          on: {
            "click": _vm.onNotificationAction
          }
        }, 'v-btn', attrs, false), [_vm._v(" " + _vm._s(_vm.notificationState.actionText || 'Close') + " ")])];
      }
    }]),
    model: {
      value: _vm.globalNotificationShow,
      callback: function ($$v) {
        _vm.globalNotificationShow = $$v;
      },
      expression: "globalNotificationShow"
    }
  }, [_vm._v(" " + _vm._s(_vm.notificationState.text) + " ")]), _c('v-app-bar', {
    ref: "appBar",
    attrs: {
      "app": ""
    }
  }, [_c('router-link', {
    staticClass: "logo-link",
    attrs: {
      "to": {
        path: '/sessions'
      }
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.isDarkTheme ? '/images/opencap-logo-dark.png' : '/images/opencap-logo.png',
      "alt": "OpenCap"
    }
  })]), _c('v-spacer', {
    staticClass: "navbar-spacer"
  }), _c('div', {
    staticClass: "navbar-actions d-flex align-center"
  }, [_vm.showNavbarSettings ? _c('div', {
    staticClass: "navbar-inline-toggles d-none d-md-flex align-center"
  }, [_vm.showSessionNavbarControls ? _c('LocalDataSaveToggle', {
    staticClass: "navbar-local-save",
    on: {
      "change": _vm.onLocalDataSaveChange
    }
  }) : _vm._e(), _vm.showLidarNavbarControls ? _c('LidarToggle', {
    staticClass: "navbar-lidar",
    on: {
      "change": _vm.onLidarChange
    }
  }) : _vm._e()], 1) : _vm._e(), _c('NavbarSettings', {
    staticClass: "navbar-settings d-flex d-md-none",
    attrs: {
      "show-local-save": _vm.showSessionNavbarControls,
      "show-lidar": _vm.showLidarNavbarControls
    },
    on: {
      "local-save-change": _vm.onLocalDataSaveChange,
      "lidar-change": _vm.onLidarChange
    }
  }), _c('v-btn', {
    staticClass: "theme-toggle d-none d-md-inline-flex",
    attrs: {
      "icon": "",
      "aria-label": _vm.themeToggleLabel,
      "title": _vm.themeToggleLabel
    },
    on: {
      "click": _vm.toggleTheme
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.isDarkTheme ? 'mdi-white-balance-sunny' : 'mdi-weather-night'))])], 1), _c('QRCodeDialog', {
    staticClass: "navbar-qr"
  }), _vm.showProfileInNavbar ? _c('profile-dropdown', {
    staticClass: "navbar-profile"
  }) : _vm._e()], 1)], 1), _c('v-main', {
    key: _vm.$route.fullPath
  }, [_c('router-view')], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }